export const E2E_USER = {
    email: 'webservicesqa2@gmail.com',
};
export const E2E_USER_BASIC = {
    email: 'webservicesqa2+basic@gmail.com',
};
export const E2E_USER_POST_REDACTOR = {
    email: 'webservicesqa2+basic3@gmail.com',
};

export const E2E_USER_EMAILS = [E2E_USER.email, E2E_USER_BASIC.email, E2E_USER_POST_REDACTOR.email] as const;

// ---------------------------------------------------------------------------
// Mock Data — shared between API handlers (back) & E2E tests (front)
// Only identifiers (names, IDs, usernames) live here.
// Full response structures & mutable state stay in the handler files.
// ---------------------------------------------------------------------------

export const E2E_MOCK_FACEBOOK = {
    userId: 'mock-fb-user-123',
    userName: 'Mock E2E Facebook User',
    credentialName: 'Mock E2E Facebook',
    credentialId: 'aaaaaaaaaaaaaaaaaaaaa001',
    pages: {
        paris: { id: 'fb-page-1', name: 'Mock FB Restaurant Paris' },
        lyon: { id: 'fb-page-2', name: 'Mock FB Café Lyon' },
        darkKitchen: { id: 'fb-page-3', name: 'Mock FB Dark Kitchen' },
    },
    instagram: {
        id: 'ig-account-1',
        name: 'mockfbrestaurant',
        username: 'mockfbrestaurant',
    },
} as const;

export const E2E_MOCK_GMB = {
    accountId: 'mock-account-123',
    locations: {
        connectable: { id: 'mock-loc-1', title: 'Mock Restaurant Connectable', placeId: 'ChIJMockPlaceId123' },
        alreadyConnected: { id: 'mock-loc-2', title: 'Mock Restaurant Already Connected', placeId: 'ChIJMockPlaceId456' },
        noMatch: { id: 'mock-loc-3', title: 'Mock Restaurant No Hyperline Match', placeId: 'ChIJMockPlaceId789' },
    },
} as const;

export const E2E_MOCK_DELIVEROO = {
    email: 'mock-deliveroo@e2e-test.com',
    userName: 'Mock Deliveroo User',
    accessToken: 'mock-deliveroo-access-token',
    company: {
        id: 'mock-company-1',
        name: 'Mock Deliveroo Company',
    },
    restaurant: {
        id: 'mock-deliveroo-restaurant-1',
        name: 'Mock Deliveroo Restaurant',
        city: 'Paris',
    },
} as const;

export const E2E_MOCK_UBEREATS = {
    accessToken: 'mock-ubereats-access-token',
    store: {
        id: 'b7960fab-1cc4-45f9-82b9-e662699646a2',
        name: 'Mock Uber Eats Restaurant',
        address: '1 Rue de Rivoli',
        city: 'Paris',
        country: 'FR',
        postalCode: '75001',
        latitude: '48.8566',
        longitude: '2.3522',
        phoneNumber: '+33123456789',
    },
} as const;

export const E2E_MOCK_POST_CAPTION = 'E2E mock post caption' as const;

export const E2E_MOCK_HYPERLINE = {
    legalEntityId: 'mock-legal-entity',
    locations: {
        withPlaceId: { id: 'mock-location-1', name: 'Mock Location With PlaceId', placeId: 'ChIJMockPlaceId123' },
        brandAccount: { id: 'mock-location-2', name: 'Mock Brand Account', placeId: null },
        noPlaceIdNoBrand: { id: 'mock-location-3', name: 'Mock Location No PlaceId No Brand', placeId: null },
        alreadyConnected: { id: 'mock-location-4', name: 'Mock Location Already Connected', placeId: 'ChIJMockPlaceId456' },
    },
} as const;
